import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Container } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function TalkTreeResources() {
  const videos = [
    {
      title: 'What is a Talk Tree?',
      src: 'https://drive.google.com/file/d/1WFMwv2kw77JZ0FiVERX70cTzg2JAJLLD/preview',
      summary: [
        'The video briefly explains what a Talk Tree is: A visualization of student dialogue in a class session.',
        'This video also explores what makes Talk Trees special including their student-centered attention to dialogue, ability to reimagine teacher learning, and their use of AI to celebrate, not evaluate student talk.',
        'This video shares teacher insights on Talk Trees and their influence on student conversations in class, namely that students felt "more ownership" in their class discussions.',
      ],
    },
    {
      title: 'Why Talk?',
      src: 'https://drive.google.com/file/d/1kWQGpNEW2dElDlZrF5xEBwAlr4Tl61jS/preview',
      summary: [
        'This video explains how and why Talk Trees leverage the Academically Productive Talk Framework to highlight and generate more impactful student-centered class discussions.',
        'This video explains each component of a Talk Tree--red, blue, and yellow flowers and leaves--and gives student talk examples of each.',
      ],
    },
    {
      title: 'How to use the Talk Trees application?',
      src: 'https://drive.google.com/file/d/1-7A1qhb64TDPme6ydyFPPG4a7a6xTO8M/preview',
      summary: [
        'This video walks through the Talk Trees interface, explaining each section of the platform including: where to access more resources, how to select a specific tree to explore, and what you can do with students using the Talk Trees.',
        'This video also explores what an overview of a Talk Tree entails from a session summary to if/when a Tree fills up.',
        'The video expands on what activities teachers can do with students using conversational scaffolds for introducing a tree, celebrating, or comparing Talk Trees. This video also highlights how to generate presentations of the Trees with the scaffolds to use with students.',
      ],
    },
  ];

  return (
    <Box sx={{ padding: '24px 32px',    maxWidth: '1200px', margin: '0 auto' }}>

      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography sx={{ fontSize: '20px', fontWeight: 500, color: '#111827',    }}>
          Get Started by Watching These Videos
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Typography sx={{ fontSize: '14px', color: '#1a56db', fontWeight: 500, cursor: 'pointer' }}>
            Help me understand Talk Trees
          </Typography>
          <Box sx={{
            width: 18, height: 18, borderRadius: '50%', backgroundColor: '#1a56db',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '11px', fontWeight: 700, cursor: 'pointer', flexShrink: 0,
          }}>i</Box>
        </Box>
      </Box>

      {/* Video cards */}
      {videos.map((video, idx) => (
        <Box
          key={idx}
          sx={{
            mb: 3,
            border: '1px solid #e5e7eb',
            borderRadius: '16px',
            overflow: 'hidden',
            backgroundColor: '#fff',
            height: 'calc(100vh - 120px)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Video title */}
          <Box sx={{ padding: '20px 24px 16px' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#111827',    textAlign: 'left' }}>
              {video.title}
            </Typography>
          </Box>

          {/* Video embed */}
          <Box sx={{ position: 'relative', flex: 1, overflow: 'hidden', mx: 3, mb: 2, borderRadius: '8px', backgroundColor: '#f3f4f6' }}>
            <iframe
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px', display: 'block' }}
              src={video.src}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>

          {/* Summary accordion */}
          <Box sx={{ mx: 3, mb: 2 }}>
            <Accordion elevation={0} sx={{ border: '1px solid #e5e7eb', borderRadius: '8px !important', '&:before': { display: 'none' } }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, fontSize: '14px',    }}>Summary</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box component="ul" sx={{ pl: 3, mt: 0 }}>
                  {video.summary.map((point, i) => (
                    <Typography key={i} component="li" sx={{ mb: 1.5, fontSize: '13.5px', color: '#374151',    textAlign: 'left' }}>
                      {point}
                    </Typography>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
      ))}
    </Box>
  );
}